import React, { useState, useRef } from "react";
import clsx from "clsx";
import AppointmentOverviewSearchBar from "@icoach/appointment/overview/AppointmentOverviewSearchBar";
import AppointmentOverviewTable from "@icoach/appointment/overview/AppointmentOverviewTable";
import AppointmentContext from "@icoach/appointment/components/AppointmentContext";
import { initBookmark } from "@icoach/appointment/staticData";
import { Card } from "@curves/ui-base";

const AppointmentOverview = props => {
	const [sourceData, setSourceData] = useState({});
	const [bookmark, setBookmark] = useState({
		...initBookmark(),
	});
	const dialogRef = useRef(null);

	const childContext = {
		dialogRef: dialogRef,
		setDialogRef: el => (dialogRef.current = el),
		sourceData,
		setSourceData,
		bookmark: bookmark,
		setBookmarkNum: num => setBookmark(pre => ({ ...pre, pageIndex: num })),
	};

	return (
		<AppointmentContext.Provider value={childContext}>
			<Card className={clsx("appointment-time-list-context", "p-3")} square isOverflowHidden>
				<AppointmentOverviewSearchBar />
				<Card.CardContent className={"pt-2"}>
					<AppointmentOverviewTable />
				</Card.CardContent>
			</Card>
		</AppointmentContext.Provider>
	);
};

export default AppointmentOverview;
